var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoStackoverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 169.61 200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2120,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.44 178.38v-48.65h21.61V200H0v-70.27h21.61v48.65z",
    fill: "#bcbbbb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.24 140.54l4.32-16.22-86.97-17.83-3.78 17.83zM49.7 82.16L130.72 120l7.56-16.22-81.02-37.83zm22.68-40l68.06 57.3 11.35-13.51-68.6-57.3-11.35 13.51zM116.14 0l-14.59 10.81 53.48 71.89 14.58-10.81zM37.81 162.16h86.43v-16.21H37.81z",
    fill: "#f48024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStackoverflow);
export default __webpack_public_path__ + "static/media/logo-stackoverflow.e3db5ec4b504809b8dea5379b5cc8834.svg";
export { ForwardRef as ReactComponent };